import { useEffect, useState } from "react";
import AppRoutes from "./routes/AppRoutes";
import LoadingScreen from "./components/layout/LoadingScreen";

export default function App() {
  const [loadingFinished, setLoadingFinished] = useState(false);
  const [showLoader, setShowLoader] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => {
      setLoadingFinished(true);
    }, 1200);

    return () => clearTimeout(timer);
  }, []);

  return (
    <>
      {showLoader && (
        <LoadingScreen
          finish={loadingFinished}
          onDone={() => setShowLoader(false)}
        />
      )}

      <AppRoutes />
    </>
  );
}
